namespace $.$$ {

	$mol_style_define( $shm_hitalama_version_label, {

		color: $mol_theme.shade,
		font: {
			size: '.75rem',
		},
		lineHeight: '1rem',
		padding: {
			top: '.25rem',
		},

	} )

}
